/**
 *
 * Alerts
 *
 */

import React, { useEffect, useState } from 'react';

import { AggregateAlertsBy } from '@ariksa/notification';
import { Box } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import { Card } from 'components/DataDisplay';
import { CustomSpinner } from 'components/DataDisplay/Spinner/CustomSpinner';
import { usePageContentContext } from 'components/Layout';
import { FindingDrawerContent } from 'containers/Findings/AlertDrawer/Components/Aggregated/FindingDrawerContent';
import { FindingDrawerHeader } from 'containers/Findings/AlertDrawer/Components/Aggregated/FindingDrawerHeader';
import { selectAlertDrawer } from 'containers/Findings/AlertDrawer/selectors';
import { actions } from 'containers/Findings/AlertDrawer/slice';
import { useSearchParams } from 'hooks/useSearchParams';

export const AggregateAlertDetails = () => {
  const dispatch = useDispatch();
  const { contentHeight } = usePageContentContext();
  const params = useParams<{ id: string }>();
  const { environmentId, accountId } = useSearchParams<{
    environmentId: string;
    accountId: string;
  }>();
  const { aggregatedAlert } = useSelector(selectAlertDrawer);
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    if (!params?.id) return;
    dispatch(
      actions.getAggregatedAlert({
        q: {
          groupIds: [params.id],
          environmentId,
          accountId,
          aggregateBy: AggregateAlertsBy.GroupId,
        },
      }),
    );
  }, [dispatch, params?.id, environmentId, accountId]);

  return (
    <Card
      header={
        <Box>
          <FindingDrawerHeader finding={aggregatedAlert.data} />
        </Box>
      }
      styles={{ card: { h: contentHeight + 'px' } }}
    >
      {aggregatedAlert.isLoading ? (
        <CustomSpinner size="xl" />
      ) : (
        <Box flex={1} w="full" h="full">
          <FindingDrawerContent
            alert={aggregatedAlert.data}
            tabIndex={tabIndex}
            setTabIndex={setTabIndex}
          />
        </Box>
      )}
    </Card>
  );
};
